module.exports = __webpack_public_path__ + "static/img/8bg_1.3baf97a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_1.png
// module id = 747
// module chunks = 1